// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csOnlinePaymentV1', ['bmHttpUtils', 'bluemoon.components.session']).service('csOnlinePaymentV1',
        ['$http', 'bmHttpUtils',
        function($http, bmHttpUtils) {
            return {
                cleanupOnlinePayment: function(params, suppressErrors) {
                    var url = '/api/core/v1/online-payments/cleanup';
                    var strippedData = bmHttpUtils.getStrippedObject(params['cleanupPaymentDetailDto'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['cleanupPaymentDetailDto'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                dataIntegrityCheck: function(params, suppressErrors) {
                    var url = '/api/core/v1/online-payments/data-integrity-check';
                    var strippedData = bmHttpUtils.getStrippedObject(params['dataIntegritySourceDto'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['dataIntegritySourceDto'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                postprocessOnlinePayment: function(params, suppressErrors) {
                    var url = '/api/core/v1/online-payments/postprocess';
                    var strippedData = bmHttpUtils.getStrippedObject(params['authorizedPaymentDetailV1Dto'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['authorizedPaymentDetailV1Dto'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                preprocessOnlinePayment: function(params, suppressErrors) {
                    var url = '/api/core/v1/online-payments/preprocess';
                    var strippedData = bmHttpUtils.getStrippedObject(params['preprocessingPaymentDetailV1Dto'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['preprocessingPaymentDetailV1Dto'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                },

                createPaymentSetupRequest: function(params, suppressErrors) {
                    var url = '/api/core/v1/online-payments/setup';
                    var strippedData = bmHttpUtils.getStrippedObject(params['paymentSourceDto'], '$', 'Expanded');
                    return bmHttpUtils.unwrapAndValidateHttpPromise(params['paymentSourceDto'],
                        $http({url: url, method: 'POST', params: {}, headers: {}, data: strippedData }), suppressErrors);
                }

            };
        }]);
}(window.angular));
